import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import Button from "react-bootstrap/Button";
import { Col, Row, Table, InputGroup, FormControl } from "react-bootstrap";
import { getUserSession } from "../component/userInfo";
import { Link, NavLink } from "react-router-dom";
import PagingNav from "../component/PagingNav";
import { getSundayList } from "../component/MyUtils";

const WeeklyList = () => {
  const [paging, setPaging] = useState();
  const [weeklyList, setWeeklyList] = useState([]);
  const [perpage, setPerpage] = useState(10);
  const [keyword, setKeyword] = useState("");
  const [tempKeyword, setTempKeyword] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [tempStartDate, setTempStartDate] = useState("");
  const [tempEndDate, setTempEndDate] = useState("");

  useEffect(() => {
    fetchWeeklyList(1);
  }, [keyword, perpage, startDate, endDate]);

  const fetchWeeklyList = (page) => {
    const userSession = getUserSession();
    const formData = new FormData();
    formData.append("uid", userSession.uid);
    formData.append("action", "weeklylist");
    formData.append("perpage", perpage);
    if (page) formData.append("page", page);
    if (keyword) formData.append("keyword", keyword);
    if (startDate) formData.append("fromdate", startDate);
    if (endDate) formData.append("todate", endDate);

    fetch("https://work.wekoinonia.org/json/weekly.php", {
      method: "POST",
      body: formData,
    })
      .then((res) => {
        return res.json(); //Promise 반환
      })
      .then((json) => {
        console.log(json); // 서버에서 주는 json데이터가 출력 됨
        if (json.paging) {
          setPaging(json.paging);
        }
        if (json.list) {
          setWeeklyList(json.list);
        } else {
          setWeeklyList([]);
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  const getPage = (page) => {
    console.log("page = ", page);
    fetchWeeklyList(page);
  };

  const handleSearch = () => {
    console.log("handleSearch ::: ");
    setKeyword(tempKeyword);
    setStartDate(tempStartDate);
    setEndDate(tempEndDate);
  };

  const handlePerpageChange = (e) => {
    setPerpage(parseInt(e.target.value, 10));
  };

  const formatChangeTime = (dateTimeString) => {
    if (!dateTimeString) return "";
    const date = new Date(dateTimeString);
    const today = new Date();

    if (
      date.getFullYear() === today.getFullYear() &&
      date.getMonth() === today.getMonth() &&
      date.getDate() === today.getDate()
    ) {
      // It's today, return time
      return date.toLocaleTimeString("ko-KR"); // HH:mm:ss
    } else {
      // Not today, return date
      return date.toISOString().split("T")[0]; // YYYY-MM-DD
    }
  };

  return (
    <div id="content">
      <div className="container-fluid">
        <h1 className="h3 mb-2 text-gray-800">주보</h1>
        <p className="mb-4"></p>

        <div className="card shadow mb-4">
          <div className="card-body">
            <div>
              <div
                id="dataTable_wrapper"
                className="dataTables_wrapper dt-bootstrap4"
              >
                <div className="dataTable-top">
                  <div className="dataTable-dropdown">
                    <label>
                      <select
                        className="dataTable-selector"
                        value={perpage}
                        onChange={handlePerpageChange}
                      >
                        <option value="5">5</option>
                        <option value="10">10</option>
                        <option value="15">15</option>
                        <option value="20">20</option>
                        <option value="25">25</option>
                      </select>
                    </label>
                  </div>
                  <div className="dataTable-search">
                    <InputGroup>
                      <FormControl
                        type="date"
                        value={tempStartDate}
                        onChange={(e) => setTempStartDate(e.target.value)}
                      />
                      <InputGroup.Text>부터</InputGroup.Text>
                      <FormControl
                        type="date"
                        value={tempEndDate}
                        onChange={(e) => setTempEndDate(e.target.value)}
                      />
                      <InputGroup.Text>까지</InputGroup.Text>
                      <FormControl
                        className="dataTable-input"
                        placeholder="제목으로 조회"
                        value={tempKeyword}
                        onChange={(e) => setTempKeyword(e.target.value)}
                        onKeyPress={(e) => e.key === "Enter" && handleSearch()}
                      />
                      <Button variant="primary" onClick={handleSearch}>
                        조회
                      </Button>
                    </InputGroup>
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-12">
                    <Table striped bordered hover>
                      <thead>
                        <tr>
                          <th>No</th>
                          <th>날짜</th>
                          <th>제목</th>
                          <th>등록자</th>
                          <th>수정일</th>
                          <th>이미지</th>
                        </tr>
                      </thead>
                      <tbody>
                        {weeklyList.map((item, index) => {
                          return (
                            <tr key={index}>
                              <td>{item.weekly_no}</td>
                              <td>
                                <Link
                                  to={`/WeeklyForm?weeklyDate=${item.weeklydate}`}
                                >
                                  {item.weeklydate}
                                </Link>
                              </td>
                              <td>{item.summary}</td>
                              <td>{item.changer_name}</td>
                              <td>{formatChangeTime(item.change_time)}</td>
                              <td>
                                <img
                                  src={
                                    "http://www.wekoinonia.org" + item.imgsrc
                                  }
                                  style={{ width: "3em", height: "3em" }}
                                />
                              </td>
                            </tr>
                          );
                        })}
                        {weeklyList.length === 0 && (
                          <tr>
                            <td colSpan="6" className="text-center">
                              해당 데이터가 없습니다.
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </div>
                </div>
                <Row>
                  <Col lg={8} className="mx-auto">
                    <PagingNav paging={paging} callback={getPage} />
                  </Col>
                  <Col lg={4} className="d-flex justify-content-end">
                    <Link to="/WeeklyForm">
                      <Button
                        variant="primary"
                        type="button"
                        style={{ width: "8rem" }}
                      >
                        등록
                      </Button>
                    </Link>
                  </Col>
                </Row>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WeeklyList;
